import ReactQuill from 'react-quill-new';

import EditorToolbar, { formats } from './EditorToolbar';
import { StyledEditor } from './styles';
import { EditorProps } from './types';

export default function Editor({
  id = 'minimal-quill',
  error,
  value,
  onChange,
  simple = false,
  helperText,
  sx,
  ...other
}: EditorProps) {
  const modules = {
    toolbar: { container: `#${id}` },
    history: { delay: 500, maxStack: 100, userOnly: true },
    clipboard: { matchVisual: false },
  };

  return (
    <>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
          }),
          ...sx,
        }}
      >
        <EditorToolbar id={id} isSimple={simple} />

        <ReactQuill
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          preserveWhitespace
          {...other}
        />
      </StyledEditor>

      {helperText && helperText}
    </>
  );
}
